import { render, staticRenderFns } from "./AntiCorruptionMeasures.vue?vue&type=template&id=8203358e&scoped=true&"
import script from "./AntiCorruptionMeasures.vue?vue&type=script&lang=js&"
export * from "./AntiCorruptionMeasures.vue?vue&type=script&lang=js&"
import style0 from "./AntiCorruptionMeasures.vue?vue&type=style&index=0&id=8203358e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8203358e",
  null
  
)

export default component.exports